"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const react_1 = tslib_1.__importDefault(require("react"));
const react_moment_1 = tslib_1.__importDefault(require("react-moment"));
const reactstrap_1 = require("reactstrap");
const react_2 = require("@osmosys/react");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const PreviewModal_1 = require("../../reusables/PreviewModal");
const react_use_1 = require("react-use");
exports.OsmosysLogTerminalLog = props => {
    const { log, index } = props;
    const { timestamp, plainTextMessage, level, message, imageUrl, linkUrl, previewHtml, } = log;
    const imgComp = imageUrl && (react_1.default.createElement(react_2.OsmosysTooltip, { span: true, label: react_1.default.createElement("div", { className: "ml-1 bg-transparent-grid-on-img rounded-sm" },
            react_1.default.createElement("img", { style: {
                    height: 'auto',
                    maxWidth: '100%',
                    width: 450,
                }, src: imageUrl })) },
        react_1.default.createElement("a", { target: "_blank", rel: "noopener noreferrer", className: "ml-1 osmosys-converter-image", href: imageUrl },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faImage }))));
    const linkComp = linkUrl && (react_1.default.createElement(react_2.OsmosysTooltip, { span: true, label: linkUrl },
        react_1.default.createElement("a", { href: linkUrl, target: "_blank", className: "ml-1", rel: "noopener noreferrer" },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { className: "osmosys-converter-screenshot-icon", icon: pro_light_svg_icons_1.faExternalLink }))));
    const [isOpen, toggle] = react_use_1.useToggle(false);
    const previewComp = previewHtml && (react_1.default.createElement(react_2.OsmosysTooltip, { span: true, label: "Preview HTML" },
        react_1.default.createElement("a", { href: "#", onClick: e => {
                e.preventDefault();
                toggle();
            }, target: "_blank", className: "ml-1", rel: "noopener noreferrer" },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { className: "osmosys-converter-screenshot-icon", icon: pro_light_svg_icons_1.faCode })),
        react_1.default.createElement(PreviewModal_1.PreviewModal, { html: previewHtml, isOpen: isOpen, onClose: toggle, title: "Preview HTML" })));
    return (react_1.default.createElement(reactstrap_1.Collapse, { isOpen: true, className: "log-item" },
        react_1.default.createElement("p", { className: "mt-0 mb-1", key: `${timestamp.getTime()}-${index}`, title: plainTextMessage },
            react_1.default.createElement(react_2.OsmosysTooltip, { span: true, label: react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_moment_1.default, { date: timestamp, fromNow: true }),
                    " (",
                    react_1.default.createElement(react_moment_1.default, { date: timestamp, format: "LTS" }),
                    ")") },
                react_1.default.createElement("span", { className: "text-muted mr-2" },
                    "[",
                    react_1.default.createElement(react_moment_1.default, { date: timestamp, className: "text-muted", format: "HH:mm:ss" }),
                    "]"),
                ' '),
            react_1.default.createElement("span", { className: classnames_1.default({
                    'text-danger': level === 'error',
                    'text-info': level === 'info',
                    'text-muted': level === 'debug',
                    'text-success': level === 'success',
                    'text-warning': level === 'warn',
                    'text-white': level === 'subheader',
                    'text-white font-weight-bold lead': level === 'header',
                }) },
                level === 'error' && (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faExclamationTriangle })),
                ' ',
                message,
                (imgComp || linkComp || previewComp) && (react_1.default.createElement("span", { className: "ml-1" },
                    imgComp,
                    linkComp,
                    previewComp))))));
};
//# sourceMappingURL=index.js.map